import * as React from "react";
import {useEffect} from "react";

const StudentList = ({ studentList, activeFilter }) => {
    const color_all = "#F1F6FF";
    const color_good = "#EDFAF3";
    const color_bad = "#FFF1F1";
    const [color, setColor] = React.useState(color_all);
    useEffect(() => {
        if(activeFilter!=null){
            if(activeFilter==="VIEW_ALL"){
                setColor(color_all);
            } else if(activeFilter==="EXCELLENT_LEARNING" || activeFilter==="COMPLETE_ALL" || activeFilter==="HIGH_ACHIEVEMENT" || activeFilter==="HIGH_ACCURACY"){
                setColor(color_good);
            }else{
                setColor(color_bad);
            }
        }
    },[activeFilter])

    return (
        <div className="flex flex-wrap justify-start gap-1 w-[320px] max-md:w-full text-sm font-semibold text-gray-600 ml-auto scroll-container  items-start content-start border-l-[1px] border-gray-200 pl-3"
             style={{
                 overflowY: "auto",
                 maxHeight: "308px",
             }}
        >
            {studentList.length > 0 ? (
                studentList.map((student, index) => (
                    <div
                        key={index}
                        className={`overflow-hidden self-stretch px-2 py-1 my-2 bg-[${color}] rounded-2xl h-[37px] w-[96px] text-ellipsis whitespace-nowrap text-center leading-[29px]`}
                    >
                        {student}
                    </div>
                ))
            ) : (
                <div className="flex justify-center items-center w-full h-full text-gray-400 text-sm">학생이 없습니다</div>
            )}
        </div>
    );
}

export default StudentList;